import { useQuery } from "@apollo/client";
import { ClientUnreadNotificationCountDocument } from "@/__generated__/graphql";
import { useAuthState } from "@/store/auth";
import { ClientInstance } from "@/lib/graphql/apollo";

export const useClientUnreadNotificationCountQuery = (shouldSkip: boolean) => {
  useQuery(ClientUnreadNotificationCountDocument, {
    skip: shouldSkip,
    pollInterval: 1000 * 30, // every 30 seconds
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      useAuthState
        .getState()
        .setUnreadNotificationCount(
          data?.clientUnreadNotificationCount?.count ?? 0,
        );
    },
  });
};

export const getUnreadNotificationCount = () => {
  const data = ClientInstance.readQuery({
    query: ClientUnreadNotificationCountDocument,
  });
  return data?.clientUnreadNotificationCount?.count ?? 0;
};
